import { render } from "./VideoCustom.vue?vue&type=template&id=02cf03dc&scoped=true"
import script from "./VideoCustom.vue?vue&type=script&lang=js"
export * from "./VideoCustom.vue?vue&type=script&lang=js"

import "./VideoCustom.vue?vue&type=style&index=0&id=02cf03dc&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02cf03dc"]])

export default __exports__